export interface TInitialsAvatarStyle {
  backgroundColor: string
  textColor: string
  borderColor: string
}

const INITIALS_AVATAR_STYLES: TInitialsAvatarStyle[] = [
  { backgroundColor: "#EAF4FF", textColor: "#18436E", borderColor: "#BFD9F5" },
  { backgroundColor: "#EEFCEB", textColor: "#24562D", borderColor: "#BFE6C2" },
  { backgroundColor: "#FFF6E8", textColor: "#7A4B08", borderColor: "#F2D6A8" },
  { backgroundColor: "#F2ECFF", textColor: "#4A2B83", borderColor: "#D8C9F8" },
  { backgroundColor: "#E9FBF7", textColor: "#0C5A4E", borderColor: "#B7E7DB" },
  { backgroundColor: "#FFF0F6", textColor: "#7A2048", borderColor: "#F5BED5" },
  { backgroundColor: "#FDECEF", textColor: "#7A1E37", borderColor: "#F6B7C8" },
  { backgroundColor: "#F1F5F9", textColor: "#334155", borderColor: "#CBD5E1" },
]

function hashSeed(seed: string) {
  let hash = 0
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash << 5) - hash + seed.charCodeAt(index)
    hash |= 0
  }

  return hash
}

export function getInitialsAvatarStyle(seed: string) {
  const normalizedSeed = seed.trim().toLowerCase() || "default"
  const paletteIndex = Math.abs(hashSeed(normalizedSeed)) % INITIALS_AVATAR_STYLES.length

  return INITIALS_AVATAR_STYLES[paletteIndex] ?? INITIALS_AVATAR_STYLES[0]
}
